<div class="op-breadcrumbs">
  <!-- Desktop Version -->
  <nav [attr.aria-label]="text.breadcrumb" class="hidden-for-mobile">
    <ol class="op-breadcrumbs--items">
      <li
        class="op-breadcrumbs--item"
        data-test-selector="op-breadcrumbs--item"
        *ngFor="let item of items; let last = last"
      >
        <ng-container *ngIf="!last">
          <ng-container *ngIf="isLink(item); else plainText">
            <a [href]="item.href" target="_top">{{ item.text }}</a>
          </ng-container>
            <ng-template #plainText>
                <a class="op-breadcrumbs--text"
                   href="#"
                   target="_top">
                    {{ item }}
                </a>
            </ng-template>
        </ng-container>
        <ng-container *ngIf="last">
          <a href="#"
            aria-current="page"
            class="op-breadcrumbs--current"
             target="_self"
          >
            <ng-container *ngIf="lastItemSection">
              <span class="op-breadcrumbs--section">{{ lastItemSection }}: </span>
            </ng-container>
            <b>{{ getText(item) }}</b>
          </a>
        </ng-container>
      </li>
    </ol>
  </nav>

  <!-- Mobile Version -->
  <nav [attr.aria-label]="text.breadcrumb" class="hidden-for-desktop">
    <div class="op-breadcrumbs--mobile" *ngIf="items.length > 1">
      <ng-container *ngIf="getHref(items[items.length - 2]) as href">
        <a class="op-breadcrumbs--back" [href]="href" target="_top">
          <svg arrow-left-icon size="small"></svg>
          {{ getText(items[items.length - 2]) }}
        </a>
      </ng-container>
    </div>
  </nav>
</div>
